module.exports = __webpack_public_path__ + "static/media/icon-CeluPass.0ff1aadd.svg";